import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">关于我们</h2>
          <p className="mt-2 text-sm text-foreground-500">了解樱花TV的故事与使命</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-10">
            <h3 className="text-lg font-semibold text-foreground-800 mb-5 font-heading tracking-wide">{aboutInfo.title}</h3>
            {aboutInfo.paragraphs.map((p, i) => (
              <p key={i} className="text-sm text-foreground-600 leading-relaxed mb-4 last:mb-0">
                {p}
              </p>
            ))}
            <div className="flex flex-wrap gap-4 mt-6 pt-6 border-t border-background-200">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-md bg-primary-500/10 flex items-center justify-center">
                  <i className="ri-4k-line text-primary-400"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">画质标准</p>
                  <p className="text-sm font-semibold text-foreground-700">1080P / 4K HDR</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-md bg-accent-500/10 flex items-center justify-center">
                  <i className="ri-global-line text-accent-400"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">CDN节点</p>
                  <p className="text-sm font-semibold text-foreground-700">全球 50+ 节点</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-md bg-secondary-500/10 flex items-center justify-center">
                  <i className="ri-user-smile-line text-secondary-400"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">服务用户</p>
                  <p className="text-sm font-semibold text-foreground-700">超过 800 万</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}